import { convertStringToBuffer } from '../commands-utils/convertStringToBuffer'

export function lpop(key) {
  if (this.data.has(key) && !(this.data.get(key) instanceof Array)) {
    throw new Error(`Key ${key} does not contain a list`)
  }
  const list = this.data.get(key) || []

  const item = list.length > 0 ? list.shift() : null

  this.data.set(key, list)

  return item
}

export function lpopBuffer(key) {
  const val = lpop.apply(this, [key])
  return convertStringToBuffer(val)
}
